// extracted by mini-css-extract-plugin
export default {"root":"_1JYoV","content":"_8UE61"};